module.exports = __webpack_public_path__ + "img/googleplay.db9b21a1.png";